import { type ReactNode } from "react";
import { useAppShell } from "@/shell/app-shell-context";

/**
 * A decisão "esta empresa mostra CENA?" mora AQUI, e só aqui.
 *
 * O valor vem de `company.displays_cena`, que chega pelo `/me` (é o que
 * monta o contexto de empresa da casca) e é atualizado pelo
 * `refreshProfile()` depois de salvar em Ajustes. O CENA continua sendo
 * CALCULADO no servidor — isto é escolha de exibição, não de cálculo, e
 * por isso o servidor segue mandando os números na resposta.
 *
 * O `?? true` cobre só `company == null` (rotas globais, fora do escopo
 * de uma empresa). Ele NÃO cobre campo esquecido em mapeamento —
 * `displays_cena` é obrigatório em `CompanyContext` exatamente pra esse
 * esquecimento ser erro de compilação em vez de "CENA nunca esconde".
 */
export function useShowsCena(): boolean {
  const { company } = useAppShell();
  return company?.displays_cena ?? true;
}

/** Envelope pra blocos de JSX: o conteúdo só renderiza com CENA ligado.
 * Pra lógica (query, early-return), use `useShowsCena()` direto. */
export function IfCena({ children }: { children: ReactNode }) {
  return useShowsCena() ? <>{children}</> : null;
}
